import axios from '../axios'

export default class AppSettingsService {
  getSetting(key) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/appSettings/' + key
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updateSetting(key, value) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/appSettings/' + key
        var response = await axios.put(path, { settingValue: value })
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  /**
   * "Tasks count as overdue from": `{ taskOverdueFrom: 'yyyy-MM-dd' | null, updatedBy }`. A task (no end time) dated
   * before it never turns Overdue or sends an overdue email; null = no such task ever does. Settings or admin users
   * only (409 otherwise).
   */
  getTaskOverdueFrom() {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.get('/v1/activitySettings/taskOverdueFrom')
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  /** `date` is 'yyyy-MM-dd' or null. */
  saveTaskOverdueFrom(date) {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.put('/v1/activitySettings/taskOverdueFrom', { taskOverdueFrom: date })
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  /**
   * Item 4 follow-up: "Active-quote comparison shown from" and the snapshot retention, plus the snapshot days held:
   * `{ compareFrom: 'yyyy-MM-dd' | null, retentionDays, minRetentionDays, shownNow, today, daysHeld, latestDays }`.
   * Settings or admin users only (409 otherwise).
   */
  getActiveQuoteCompare() {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.get('/v1/dashboardSettings/activeQuoteCompare')
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  /** `{ compareFrom: 'yyyy-MM-dd' | null, retentionDays }`. */
  saveActiveQuoteCompare(body) {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.put('/v1/dashboardSettings/activeQuoteCompare', body)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  /** Takes (or retakes) today's active-quote snapshot now. Admin only. `{ date, rows, purged }`. */
  takeActiveQuoteSnapshot() {
    return new Promise(async function (resolve, reject) {
      try {
        var response = await axios.post('/v1/dashboardSettings/activeQuoteSnapshot', {})
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}
